<template>
  <vxe-grid ref="rockTable" v-bind="gridOptions" v-on="$listeners" class="rock-table"
    :seq-config="{ startIndex: (gridOptions.pagerConfig.currentPage - 1) * gridOptions.pagerConfig.pageSize }">
    <template #operate="scope">
      <slot name="operate" :row="scope.row" :column="scope.column" />
    </template>
    <template #field_edit="scope">
      <slot name="field_edit" :row="scope.row" :column="scope.column" />
    </template>
    <template #name_header="scope">
      <slot name="name_header" :row="scope.row" :column="scope.column" />
    </template>
  </vxe-grid>
</template>

<script>
import { mapGetters } from "vuex";

const initialOptions = {
  round: true,
  border: true,
  height: "auto",
  resizable: true,
  rowConfig: {
    keyField: "id",
    isHover: true,
  },
  resizeConfig: {
    refreshDelay: 800,
  },
  pagerConfig: {
    total: 0,
    currentPage: 1,
    pageSize: 20,
    pagerCount: 5, // 显示页码按钮的数量
    pageSizes: [20, 50, 100, 200, 400],
    enabled: true,
  },
  editConfig: {
    trigger: "click", // manual（手动触发方式，只能用于 mode=row）,click（点击触发编辑）
    mode: "cell", // cell（单元格编辑模式）,row（行编辑模式）
    enabled: true,
  },
  checkboxConfig: {
    // 设置复选框支持分页勾选，需要设置 keyField 行数据主键
    reserve: true,
  },
  showOverflow: "tooltip",
  showHeaderOverflow: "tooltip",
};

export default {
  name: "RockTable",
  install(Vue) {
    Vue.component("RockTable", this);
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      gridOptions: this._.cloneDeep(initialOptions),
      pagerLayouts: [
        "PrevPage",
        "Jump",
        "PageCount",
        "NextPage",
        "Sizes",
        "Total",
      ],
      mobilePagerLayouts: [
        "PrevPage",
        "Jump",
        "PageCount",
        "NextPage",
        "Total",
      ],
    };
  },
  computed: {
    ...mapGetters({
      vxeSize: "vxeSize",
      isMobile: "isMobile",
    }),
  },
  watch: {
    options: {
      handler(val) {
        const cloneInitialOptions = this._.cloneDeep(initialOptions);
        let cloneOptions = this._.cloneDeep(val);
        if (this.isMobile && val.columns && val.columns.length) {
          cloneOptions.columns = val.columns.filter(
            (item) => item.disableCheck
          );
        }
        this.gridOptions = this._.merge(cloneInitialOptions, cloneOptions, {
          size: this.vxeSize,
          pagerConfig: {
            layouts: this.isMobile
              ? this.mobilePagerLayouts
              : this.pagerLayouts,
          },
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getCheckboxRecords() {
      return this.$refs.rockTable.getCheckboxRecords();
    },
    commitProxy(code) {
      return this.$refs.rockTable.commitProxy(code);
    },
  },
};
</script>

<style scoped lang="scss">
.rock-table {
  ::v-deep .vxe-button+.vxe-button {
    margin-left: 0 !important;
  }

  ::v-deep .vxe-button+.vxe-button--dropdown {
    margin-left: 0 !important;
  }

  ::v-deep .vxe-button--dropdown+.vxe-button {
    margin-left: 0 !important;
  }

  ::v-deep .vxe-button--dropdown+.vxe-button--dropdown {
    margin-left: 0 !important;
  }
}
</style>
